/**
 * Sync with service-partner360/app/modules/partnerPlan/helpers/sectionSettings/isSectionSettingOn.ts
 *
 * Section settings (`FORM_DATA_TABLE_621.SectionSettings`) do not keep their types: `spJBPSectionSettingsApplyChanges`
 * stores only '0', '1' and '-1' as JSON numbers and any other value as a string, and values written before
 * 2026-09-21 are strings too. So a flag can arrive as `1` or `"1"`, and `!!"0"` is `true`.
 */

/** The numeric value of a setting: a number, a string holding a number (`"1"`, `" 2 "`), or a boolean as 1 / 0. */
export const getSectionSettingNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined
  }
  if (typeof value === 'boolean') {
    return value ? 1 : 0
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const number = Number(value)

    return Number.isFinite(number) ? number : undefined
  }

  return undefined
}

/** A flag is on when its value is a non-zero number, stored as a number or as a string. */
export const isSectionSettingOn = (value: unknown): boolean => {
  const number = getSectionSettingNumber(value)

  return number !== undefined && number !== 0
}
